import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Loading } from 'src/app/domain/models/alert/loading';
import { Alert } from '../../../domain/models/alert/alert';
import { AlertGateway } from '../../../domain/models/alert/gateway/alert-gateway';
import { LoadingType } from 'src/app/domain/models/alert/loading-type-enum';

@Injectable({
  providedIn: 'root'
})
export class AlertService extends AlertGateway {
  private subjectAlert = new Subject<Alert>();
  private subjectLoading = new Subject<Loading>();
  private defaultId = 'default-alert';

  showAlert(alert: Alert) {
    alert.Id = alert.Id || this.defaultId;
    alert.AutoClose = (alert.AutoClose === undefined ? true : alert.AutoClose);
    this.subjectAlert.next(alert);
  }

  setLoading(showLoading: boolean, loadingType: LoadingType = LoadingType.Default, textsLoading: Array<string> = []) {
    this.subjectLoading.next({
      showLoading: showLoading,
      loadingType: loadingType,
      textsLoading: textsLoading
    });
  }

  onAlert(id: any): Observable<Alert> {
    return this.subjectAlert.asObservable().pipe(filter(x => x && x.Id === id));
  }

  onLoading(): Observable<Loading> {
    return this.subjectLoading.asObservable().pipe();
  }

  hideAlert(Id = this.defaultId) {
    this.subjectAlert.next({ Id: Id });
  }
}

